import React, { useRef } from 'react';
import { CommonInputProps, InputLabel } from './common';
import { Horizontal } from 'packages/radiant-react/layout';
import { Input } from 'packages/radiant-react/input';
import styles from './styles.module.scss';

const pixelValue = (value: string | undefined) => {
  return (value || '').replace('px', '');
};

interface SizeInputProps extends CommonInputProps {
  range?: {
    max: number;
    min: number;
  };
}

const SizeNumberInput: React.FC<Omit<CommonInputProps, 'name'>> = ({ onChange, value, range }) => {
  return (
    <Input.Number
      className={styles.inputRadius}
      type="number"
      onChange={(event) => onChange(event ? event + 'px' : undefined)}
      value={pixelValue(value)}
      min={range?.min}
      max={range?.max}
      step={1}
      ariaLabel={name + ' (px)'}
    />
  );
};

const SizeRangeInput: React.FC<Omit<SizeInputProps, 'name'>> = ({ onChange, range, value }) => {
  return (
    <Input.Number
      onChange={(event) => onChange(event ? event + 'px' : undefined)}
      value={pixelValue(value)}
      min={range?.min}
      max={range?.max}
      step={1}
      ariaLabel={name + ' (px)'}
      className={styles.inputRange}
    />
  );
};

export const SizeInput: React.FC<SizeInputProps> = ({ onChange, value, range, name, info }) => {
  const spanRef = useRef<HTMLSpanElement>(null);
  return (
    <Horizontal className={styles.colorInputWrapper}>
      <InputLabel name={name + ' (px)'} info={info} />
      <Horizontal className={styles.sizeInputActions}>
        <Horizontal ref={spanRef} className={styles.sizeInputWrapper}>
          {range ? (
            <SizeRangeInput onChange={onChange} value={value} range={range} />
          ) : (
            <SizeNumberInput onChange={onChange} value={value} range={range} />
          )}
        </Horizontal>
      </Horizontal>
    </Horizontal>
  );
};
